import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';
import { hasSystemPermission, hasTeamPermission, SYSTEM_ROLES } from '../data/permissions';

export const usePermissions = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data } = await supabase
          .from('profiles_1772944081397')
          .select('*')
          .eq('id', user.id)
          .single();
        setProfile(data);
      }
      setLoading(false);
    };
    fetchProfile();
  }, []);

  const canSystem = (permission) => {
    if (!profile) return false;
    return hasSystemPermission(profile.system_role, permission);
  };

  const canTeam = (permission) => {
    if (!profile) return false;
    return hasTeamPermission(profile.company_role, permission);
  };

  const isInternalStaff = () => {
    return profile && [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.MANAGER, SYSTEM_ROLES.VIEWER].includes(profile.system_role);
  };

  return { 
    profile, 
    canSystem, 
    canTeam, 
    isInternalStaff,
    loading,
    systemRole: profile?.system_role,
    teamRole: profile?.company_role
  };
};